// User display name — resolves from meta, seeds a random default on first call.
// Sync adapters may overwrite the stored name with the identity they supply.

import { getMeta, setMeta } from './db.js';

const META_KEY = 'userName';

// Default fantasy names. The whole string goes into one field
const DEFAULT_NAMES = [
    'Aldric Vanderbrook',
    'Pieter Goossens',
    'Renaud de Morteaux',
    'Florian Wyckaert',
    'Gilles Dubremetz',
    'Dirk Vermeersch',
    'Théobald Charleroix',
    'Wulfram Claerhout',
    'Emeric Delacroève',
    'Boudewijn Steenvoorde',
    'Gauthier Lepoudre',
    'Hector Wynckelmans',
    'Séverin de Gheldère',
    'Lodewijck Fasbender',
    'Arnoud Baetsleer',
    'Isolde Vanderhaegen',
    'Céleste Delvaulx',
    'Margriete Claessens',
    'Elspeth Moeremans',
    'Aurélie de Blicquy',
    'Lieselore Braeckevelt',
    'Rosalinde Charlevoix',
    'Hildegard Verberckmoes',
    'Mathilde Dumonceau',
    'Florienne de Wavreille',
    'Ysabel Moerkerke',
    'Clothilde Nachtegaele',
    'Sibylle Verstraeten',
    'Emmeline Dequesne',
    'Godelieve Vanderbrouck'
];

export function pickDefaultName() {
    const i = Math.floor(Math.random() * DEFAULT_NAMES.length);
    return DEFAULT_NAMES[i];
}

export async function getUserName() {
    const stored = await getMeta(META_KEY);
    if (stored) return stored;
    const seeded = pickDefaultName();
    await setMeta(META_KEY, seeded);
    return seeded;
}

export async function setUserName(name) {
    await setMeta(META_KEY, name);
}

export { DEFAULT_NAMES, META_KEY };
